import { IToggle } from '@appos/types';
import { get } from 'lodash';
import React, { ComponentProps, useCallback, useState, useEffect } from 'react';
import { ToggleButton } from 'react-native-paper';
import PointIcon from '../CustomIcon';
import {
  getActions,
  getItemListClick,
  getPathLibrary,
  getValueBinding,
  getValueBindingComponent,
  getConfig,
} from '../shared';
import createStyles from './style';
type Props = ComponentProps<typeof ToggleButton>;

const Toggle: React.FC<IToggle> = (attrs) => {
  const {
    attributes,
    onPress,
    id,
    data,
    initId = '',
    record,
    isInCustomList,
  } = attrs;
  const styles = createStyles(attributes);

  const [isActive, setIsActive] = useState<boolean | null>(null);

  useEffect(() => {
    const paths = getPathLibrary(getConfig(attrs));
    const getValue = getValueBindingComponent(attrs, paths[0]);
    if (isActive !== null) return;
    if (getValue !== null) {
      setIsActive(getValue);
    }
  }, [attrs]);

  const handleToggle = (actionProps: any) => {
    setIsActive(!isActive);
    if (!actionProps) return;
    onPress(actionProps.actionId, {
      itemListClick: getItemListClick(record),
    });
  };

  const childProps: Props = {
    status: 'unchecked',
    icon: isActive
      ? attributes.activeIcon === 'point'
        ? () => (
            <PointIcon
              width={attributes.size}
              height={attributes.size}
              fill={attributes.activeColor}
            />
          )
        : attributes.activeIcon
      : attributes.inactiveIcon === 'point'
      ? () => (
          <PointIcon
            width={attributes.size}
            height={attributes.size}
            fill={attributes.inactiveColor}
          />
        )
      : attributes.inactiveIcon,
    color: isActive ? attributes.activeColor : attributes.inactiveColor,
    size: attributes.size,
  };

  const handlePress = useCallback(async () => {
    const { clickActions, activeActions, inactiveActions } = attributes;

    if (!onPress) return;

    if (!!isActive && activeActions) {
      await handleToggle(activeActions);
      return;
    }

    if (!isActive && inactiveActions) {
      await handleToggle(inactiveActions);
      return;
    }

    return handleToggle(clickActions);
  }, [isActive]);

  return (
    <ToggleButton onPress={handlePress} style={styles.icon} {...childProps} />
  );
};

export default Toggle;
